import Vue from 'vue'

// Tooltips
Vue.component('tooltips', require('./Tooltip').default);

// Video Training
Vue.component('video-player', require('./Training/VideoPlayer'));

// Series
Vue.component('training-series', require('./Training/Series/Index'));
Vue.component('training-create-serie-modal', require('./Training/Series/Create').default);
Vue.component('training-update-serie-modal', require('./Training/Series/Update').default);
Vue.component('training-delete-serie-modal', require('./Training/Series/Delete').default);

// Videos
Vue.component('training-videos', require('./Training/Videos/Index'));
Vue.component('training-serie-upload-video', require('./Training/Videos/Create').default);
Vue.component('training-serie-update-video', require('./Training/Videos/Update').default);
Vue.component('training-serie-delete-video', require('./Training/Videos/Delete').default);

// Video Comments
Vue.component('video-comments', require('./Training/Comments/Comments').default);
Vue.component('video-comment-form', require('./Training/Comments/Form').default);
Vue.component('video-comments-list', require('./Training/Comments/List').default);

// Dashboard
Vue.component('dashboard', require('./Dashboard/Index'));
Vue.component('project-space-areas', require('./Dashboard/SpaceAreas'));
Vue.component('project-forms', require('./Dashboard/ProjectForms'));
Vue.component('view-type-selector', require('./Dashboard/ViewTypeSelector').default);
Vue.component('tree-view', require('./Dashboard/TreeView').default);
Vue.component('space-without-photos-alert', require('./Dashboard/NoPhotoOnSpaceAlert').default);

// Project
Vue.component('projects', require('./Projects/Index'));
Vue.component('project-status-legend', require('./Projects/Legend').default);
Vue.component('projects-table', require('./Projects/Table').default);
Vue.component('project-create', require('./Projects/Create').default);
Vue.component('project-void-toggle', require('./Projects/ToggleVoid').default);

// Uncompleted
Vue.component('uncompleted-project-target-date', require('./Projects/ProjectTargetDate').default);

// Settings
Vue.component('project-settings', require('./Settings/Index'));
Vue.component('project-settings-groups', require('./Settings/Groups').default);
Vue.component('project-settings-manufactures', require('./Settings/Manufactures').default);
Vue.component('project-permit-number-file', require('./Settings/PermitNumberFile').default);
Vue.component('project-calendar-link', require('./Settings/CalendarLink').default);

// Work Team
Vue.component('project-work-team', require('./WorkTeam/Index').default);
Vue.component('work-team-search', require('./WorkTeam/Search').default);
Vue.component('work-team-user', require('./WorkTeam/Invite').default);
Vue.component('work-team-invited-user', require('./WorkTeam/InvitedUser').default);
Vue.component('work-team-responsible', require('./WorkTeam/Responsible').default);

// Author Information
Vue.component('author-information', require('./Author/Index'));

// Notes
Vue.component('notes-model', require('./Notes/Notes').default);
Vue.component('create-note', require('./Notes/Create').default);
Vue.component('update-note', require('./Notes/Update').default);
Vue.component('delete-note', require('./Notes/Delete').default);

// Spaces
Vue.component('space-area', require('./Spaces/Index'));
Vue.component('space-create', require('./Spaces/Create').default);
Vue.component('space-update', require('./Spaces/Update').default);
Vue.component('space-delete', require('./Spaces/Delete').default);
Vue.component('space-area-preview', require('./Spaces/Preview').default);

// Untested Areas 2016 && 2019
Vue.component('space-untested-areas', require('./UntestedForms/2016/UntestedAreas').default);

// Untested Forms 2020
Vue.component('sample-untested-form-rows', require('./UntestedForms/SampleUntestedFormRows').default);

// Demand Response Untested
Vue.component('sample-untested-demand-response', require('./UntestedForms/SampleUntestedDemandResponse').default);
Vue.component('sample-untested-demand-response-group', require('./UntestedForms/SampleUntestedDemandResponseGroup').default);

// Space Photo
Vue.component('space-photos', require('./Spaces/Photo'));
require('./Spaces/Photo');

// Files
Vue.component('files-model', require('./Files/Files').default);
Vue.component('delete-file-modal', require('./Files/Delete').default);
Vue.component('preview-file-modal', require('./Files/Preview').default);

// Proeject Forms
Vue.component('project-forms-create', require('./ProjectForms/Create').default);

// Forms
require('./Forms/versions/Index')
Vue.component('test-result-icon', require('./Forms/ResultIcon').default);
Vue.component('form-selector', require('./Forms/FormSelector').default);
Vue.component('form-checkbox', require('./Forms/FormCheckbox').default);

// Acceptance Documents
Vue.component('acceptance-documents', require('./AcceptanceDocuments/Index'))
Vue.component('signatures', require('./AcceptanceDocuments/Signatures'));
Vue.component('author-signatures', require('./AcceptanceDocuments/AuthorSignatures'));
Vue.component('request-unlock', require('./AcceptanceDocuments/Unlcok').default);
Vue.component('acceptance-documents-delete', require('./AcceptanceDocuments/Delete').default);
Vue.component('acceptance-documents-history', require('./AcceptanceDocuments/Documents').default);
Vue.component('confirm-acceptance-document-information', require('./AcceptanceDocuments/ConfirmInformation').default)

// Charts
Vue.component('chart-projects-timeline', require('./Charts/ProjectsTimeline').default);

// Stripe
Vue.component('payment-form', require('./Stripe/PaymentForm').default);

// Helpers
Vue.component('modal', require('./Modal').default);
Vue.component('dropzone', require('./Dropzone').default);
Vue.component('paginator', require('./Paginator').default);
Vue.component('search-user', require('./SearchUser').default);
Vue.component('image-upload', require('./ImageUpload').default);
Vue.component('feedback-modal', require('./FeedbackModal').default);
Vue.component('pending-field-audit-modal', require('./PendingFieldAuditsModal').default);
// Vue.component('submit-button', require('./SubmitButton').default);
// Vue.component('simple-paginator', require('./SimplePaginator').default);
Vue.component('display-image-modal', require('./DisplayImageModal').default);
Vue.component('cec-database-of-devices', require('./DatabaseOfDevices').default);

// Fileds Inputs.
Vue.component('field-text', require('./Input/Text').default);
Vue.component('field-tags', require('./Input/Tags').default);
Vue.component('field-file', require('./Input/File').default);
Vue.component('field-input', require('./Input/Input').default);
Vue.component('field-phone', require('./Input/Phone').default);
Vue.component('field-radio', require('./Input/Radio').default);
Vue.component('field-select', require('./Input/Select').default);
Vue.component('field-switch', require('./Input/Switch').default);
Vue.component('field-toggle', require('./Input/Toggle').default);
Vue.component('field-datetime', require('./Input/Datetime').default);
Vue.component('field-timezone', require('./Input/Timezone').default);
Vue.component('field-checkbox', require('./Input/Checkbox').default);
Vue.component('field-state-counties', require('./Input/StateCounties').default);

// Management
require('./Management')

// Field Inspections & Desk Audits
require('./Auditable')
